import ParserInterface from './parser-interface';
import Parser from './parser';

const CsvContentParserFactory = {
    getParser(sportConfig): ParserInterface {
        return new Parser();
    },
};

export default CsvContentParserFactory;
